import { Bool } from './common'

// 处方分类 1:西药方 3:草药方 4:治疗 6:检查 7:其他 12:颗粒草药方 13:处置项目 14:输注方 15:中药贴敷方 16:中医外治处方 101:预收挂号费 102:额外费用
export enum RecipeCategory {
  Medicine = 1,
  Tcm = 3,
  Treatment = 4,
  Examination = 6,
  Others = 7,
  Dispose = 13,
  TcmGranules = 12,
  TcmApply = 15,
  TcmTreat = 16,
  ShuZhuFang = 14,
  Registration = 101,
  Extras = 102,
}
export const EditableRecipeCategories = [
  RecipeCategory.Medicine,
  RecipeCategory.Tcm,
  RecipeCategory.TcmGranules,
  RecipeCategory.TcmTreat,
  RecipeCategory.ShuZhuFang,
  RecipeCategory.Treatment,
  RecipeCategory.Examination,
  RecipeCategory.Dispose,
  RecipeCategory.Others,
]

export const EditableRecipeCategoriesWithTcmApply = [
  RecipeCategory.Medicine,
  RecipeCategory.Tcm,
  RecipeCategory.TcmGranules,
  RecipeCategory.TcmTreat,
  RecipeCategory.TcmApply,
  RecipeCategory.ShuZhuFang,
  RecipeCategory.Treatment,
  RecipeCategory.Examination,
  RecipeCategory.Dispose,
  RecipeCategory.Others,
]

export const ToothEditableRecipeCategories = [
  RecipeCategory.Medicine,
  RecipeCategory.Treatment,
  RecipeCategory.Examination,
  RecipeCategory.Dispose,
  RecipeCategory.Others,
]

export function isTcmRecipeCategory(category?: RecipeCategory): boolean {
  return (
    category === RecipeCategory.Tcm ||
    category === RecipeCategory.TcmGranules ||
    category === RecipeCategory.TcmApply 
  )
}

export function getRecipeCategoryName(category: RecipeCategory): string {
  switch (category) {
    case RecipeCategory.Medicine:
      return '西药/成药方'
    case RecipeCategory.Tcm:
      return '中药方'
    case RecipeCategory.TcmGranules:
      return '颗粒草药方'
    case RecipeCategory.TcmTreat:
      return '中医治疗方'
    case RecipeCategory.TcmApply:
      return '中药贴敷方'
    case RecipeCategory.ShuZhuFang:
      return '输注方'
    case RecipeCategory.Treatment:
      return '治疗'
    case RecipeCategory.Examination:
      return '检查'
    case RecipeCategory.Dispose:
      return '处置项目'
    case RecipeCategory.Others:
      return '其他'
    case RecipeCategory.Extras:
      return '其他费用'
    case RecipeCategory.Registration:
      return '挂号'
  }
  return ''
}

export function getSortRecipeCategoryName(name: any): any {
  switch (name) {
    case '西药/成药方':
      return  1
    case '中药方':
      return  2
    case '颗粒草药方':
      return  3
    case '中医治疗方':
      return  4
    case '中药贴敷方':
      return  5
    case '输注方':
      return  6
    case '治疗':
      return  7
    case '检查':
      return  8
    case '处置项目':
      return  9
    case '其他':
      return  10
    case '其他费用':
      return  11
    case '挂号':
      return  12
  }
  return ''
}

// TO_SETTLE(0, "未结算(待收费)"), IN_SETTLE(1, "结算中"),
// SETTLED_TO_CONFIRM(2, "已结算未确认"), SETTLED(3, "已结算(已收费)"),
// IN_RETURN(4, "退费中"), RETURNED(5, "已退费");
export enum RecipeStatus {
  Unknown = -1,
  ToSettle = 0,
  InSettle = 1,
  SettledToConfirm = 2,
  Settled = 3,
  InReturn = 4,
  Returned = 5,
  JuHe = 6,
  juhePay = 7, // 聚合支付
  oweMone = 8, //欠费管理
  invoice = 9, // 电子发票
}
export enum MedicalStatus {
  NoZd = 1, // 未填写诊断
  JBNoZsZlyj = 2, // 待完善 未填写主诉 未填写治疗意见
  WZZsZlyj = 3, // 完整 填写主诉 填写治疗意见
}

export const MedicalStatusCategories = [
  MedicalStatus.NoZd,
  MedicalStatus.JBNoZsZlyj,
  MedicalStatus.WZZsZlyj,
]
export function isRecipePayableForSyld(recipe: Recipe): boolean {
  return (
    (recipe.state === RecipeStatus.ToSettle ||
    recipe.state === RecipeStatus.Unknown) && (recipe.amount > 0)
  )
}
export function isRecipePayable(recipe: Recipe): boolean {
  return (
    recipe.state === RecipeStatus.ToSettle ||
    recipe.state === RecipeStatus.Unknown
  )
}

export function getRecipeStatusName(status: RecipeStatus): string {
  switch (status) {
    case RecipeStatus.Unknown:
      return '未结算'
    case RecipeStatus.ToSettle:
      return '未结算'
    case RecipeStatus.InSettle:
      return '结算中'
    case RecipeStatus.SettledToConfirm:
      return '已结算未确认'
    case RecipeStatus.Settled:
      return '已结算'
    case RecipeStatus.InReturn:
      return '退费中'
    case RecipeStatus.Returned:
      return '已退费'
    case RecipeStatus.JuHe:
      return '聚合支付退费'
    case RecipeStatus.oweMone:
      return '欠费管理'
  }
  return ''
}
export function getMedicalState(status: number): any {
  switch (status) {
    case 1:
      return '待完善'
    case 2:
      return '基本完整'
    case 3:
      return '完整病历'
  }
  return ''
}

export function getMedicalStateColumnType(medicalState: MedicalStatus): string {
  if (medicalState == MedicalStatus.NoZd) {
    return '待完善'
  } else if (medicalState == MedicalStatus.JBNoZsZlyj) {
    return '基本完整'
  } else if (medicalState == MedicalStatus.WZZsZlyj) {
    return '完整病历'
  } 
  return '-'
}

export function getMedicalStateColumnTypeColor(medicalState: any): string {
  if (medicalState == MedicalStatus.NoZd) {
    return '#ff8f2b'
  } else if (medicalState == MedicalStatus.JBNoZsZlyj) {
    return '#027aff'
  } else if (medicalState == MedicalStatus.WZZsZlyj) {
    return '#333333'
  }
  return '已完成'
}
'#027aff'

export function getCheckState(qcCode: any): string {
  switch (qcCode) {
    case '0':
      return '无异常'
    case '1':
      return '阻断'
    case '2':
      return '提醒'
    case '3':
      return '转自费'
  }
  return ''
}

export interface Recipe {
  id: string
  category: RecipeCategory
  treatmentId: string
  doctorId: string
  doctorName: string
  patientId: string
  recipeTime: string
  amount: number
  name: string
  phone: string
  email: string
  executeState: Bool
  state: number
  invoiceFlag: string
  useMethod: string
  tip: number
  itemList?: []
  groupList?: []
  materialsExists?: number
  treatmentExists?: number
  replaceMakePrice?: number
  oneselfAmount?: number
  insuranceAmount?: number
  registrationId?: string
  feeAmountWithoutPotion?: any
  YBReplaceMakePrice?: any
  insuranceTipAmount?: any
  zifeiTipAmount?: any
  totalTipAmount?: any
  recipeNormalFrequency?: any
  recipeNormalUsemethod?: any
  remark?: any
  recipeNormalDose?: any
  prescriptionReminders?: any
  ybRxFlag?: number
  haveExecuteRecord?: boolean
  payStatus?: number
  unpaidAmount?: number
  paidAmount?: number
  refundAmount?: number
}

export function fromJson(json: any): Recipe {
  return {
    id: json.id?.toString() || '',
    category: json.category,
    treatmentId: json.treatmentId?.toString() || '',
    doctorId: json.doctorId?.toString() || '',
    doctorName: json.doctorName,
    patientId: json.patientId?.toString() || '',
    recipeTime: json.recipeTime,
    amount: json.amount,
    executeState: json.executeState,
    name: json.name,
    phone: json.phone,
    email: json.email,
    invoiceFlag: json.invoiceFlag,
    state: json.state,
    useMethod: json.useMethod,
    tip: json.tip,
    itemList: json.itemList,
    groupList: json.groupList,
    materialsExists: json.materialsExists,
    treatmentExists: json.treatmentExists,
    replaceMakePrice: json.replaceMakePrice,
    oneselfAmount: json.oneselfAmount,
    insuranceAmount: json.insuranceAmount,
    registrationId: json.registrationId,
    feeAmountWithoutPotion: json.feeAmountWithoutPotion,
    YBReplaceMakePrice: json.YBReplaceMakePrice,
    insuranceTipAmount: json.insuranceTipAmount,
    zifeiTipAmount: json.zifeiTipAmount,
    totalTipAmount: json.totalTipAmount,
    recipeNormalFrequency: json.recipeNormalFrequency,
    recipeNormalUsemethod: json.recipeNormalUsemethod,
    remark: json.remark,
    recipeNormalDose: json.recipeNormalDose,
    prescriptionReminders: json?.prescriptionReminders,
    ybRxFlag: json?.ybRxFlag,
    haveExecuteRecord: json?.haveExecuteRecord,
    payStatus: json?.payStatus,
    unpaidAmount: json?.unpaidAmount,
    paidAmount: json?.paidAmount,
    refundAmount: json?.refundAmount,
  }
}

export function getNormalFrequencyCodeCalc(normalFrequency: any) {
  switch (normalFrequency) {
    case '立即':
      return 0
    case '必要时使用':
      return 0
    case '每半小时一次':
      return 48
    case '每半小时1次':
      return 48
    case '每小时一次':
      return 24
    case '每小时1次':
      return 24
    case '每2小时一次':
      return 12
    case '每2小时1次':
      return 12
    case '每二小时一次':
      return 12
    case '每二小时1次':
      return 12
    case '每 3 小时一次':
      return 8
    case '每3小时一次':
      return 8
    case '每3小时1次':
      return 8
    case '每 3 小时1次':
      return 8
    case '每 三 小时1次':
      return 8
    case '每三小时1次':
      return 8
    case '每 三 小时一次':
      return 8
    case '每三小时一次':
      return 8
    case '每4小时一次':
      return 6
    case '每4小时1次':
      return 6
    case '每四小时一次':
      return 6
    case '每四小时1次':
      return 6
    case '每 5 小时一次':
      return 4.8
    case '每5小时一次':
      return 4.8
    case '每5小时1次':
      return 4.8
    case '每 5 小时1次':
      return 4.8
    case '每 五 小时1次':
      return 4.8
    case '每五小时1次':
      return 4.8
    case '每 五 小时一次':
      return 4.8
    case '每五小时一次':
      return 4.8
    case '每6小时一次':
      return 4
    case '每6小时1次':
      return 4
    case '每六小时一次':
      return 4
    case '每六小时1次':
      return 4
    case '每8小时一次':
      return 3
    case '每8小时1次':
      return 3
    case '每八小时一次':
      return 3
    case '每八小时1次':
      return 3
    case '每12小时一次':
      return 2
    case '每12小时1次':
      return 2
    case '每十二小时一次':
      return 2
    case '每十二小时1次':
      return 2
    case '每晚一次':
      return 1
    case '每晚1次':
      return 1
    case '每天一次':
      return 1
    case '每天1次':
      return 1
    case '每日一次':
      return 1
    case '每日1次':
      return 1
    case '每天二次':
      return 2
    case '每天2次':
      return 2
    case '每天三次':
      return 3
    case '每天3次':
      return 3
    case '每日三次':
      return 3
    case '每日3次':
      return 3
    case '每天四次':
      return 4
    case '每天4次':
      return 4
    case '每日四次':
      return 4
    case '每日4次':
      return 4
    case '每天五次':
      return 5
    case '每天5次':
      return 5
    case '每日五次':
      return 5
    case '每日5次':
      return 5
    case '隔天一次':
      return 0.5
    case '隔日一次':
      return 0.5
    case '隔日1次':
      return 0.5
    case '隔天1次':
      return 0.5
    case '每三天一次':
      return 0.33
    case '每三天1次':
      return 0.33
    case '每3天1次':
      return 0.33
    case '每3天一次':
      return 0.33
    case '五天一次':
      return 0.2
    case '五天1次':
      return 0.2
    case '5天一次':
      return 0.2
    case '5天1次':
      return 0.2
    case '五日一次':
      return 0.2
    case '五日1次':
      return 0.2
    case '5日一次':
      return 0.2
    case '5日1次':
      return 0.2
    case '十天一次':
      return 0.1
    case '十天1次':
      return 0.1
    case '10天一次':
      return 0.1
    case '10天1次':
      return 0.1
    case '十日一次':
      return 0.1
    case '十日1次':
      return 0.1
    case '10日一次':
      return 0.1
    case '10日1次':
      return 0.1
    case '每周一次':
      return 0.14
    case '每周1次':
      return 0.14
    case '每周二次':
      return 0.28
    case '每周2次':
      return 0.28
    case '每周三次':
      return 0.42
    case '每周3次':
      return 0.42
    case '每二周一次':
      return 0.07
    case '每二周1次':
      return 0.07
    case '每2周1次':
      return 0.07
    case '每2周一次':
      return 0.07
    default:
      return 0
  }
}

export function getNewNormalFrequencyCodeCalc(normalFrequency: any) {
  switch (normalFrequency) {
    case '立即':
      return 0
    case '必要时使用':
      return 0
    case '每半小时一次':
      return 48
    case '每半小时1次':
      return 48
    case '每小时一次':
      return 24
    case '每小时1次':
      return 24
    case '每2小时一次':
      return 12
    case '每2小时1次':
      return 12
    case '每二小时一次':
      return 12
    case '每二小时1次':
      return 12
    case '每 3 小时一次':
      return 8
    case '每3小时一次':
      return 8
    case '每3小时1次':
      return 8
    case '每 3 小时1次':
      return 8
    case '每 三 小时1次':
      return 8
    case '每三小时1次':
      return 8
    case '每 三 小时一次':
      return 8
    case '每三小时一次':
      return 8
    case '每4小时一次':
      return 6
    case '每4小时1次':
      return 6
    case '每四小时一次':
      return 6
    case '每四小时1次':
      return 6
    case '每 5 小时一次':
      return 4.8
    case '每5小时一次':
      return 4.8
    case '每5小时1次':
      return 4.8
    case '每 5 小时1次':
      return 4.8
    case '每 五 小时1次':
      return 4.8
    case '每五小时1次':
      return 4.8
    case '每 五 小时一次':
      return 4.8
    case '每五小时一次':
      return 4.8
    case '每6小时一次':
      return 4
    case '每6小时1次':
      return 4
    case '每六小时一次':
      return 4
    case '每六小时1次':
      return 4
    case '每8小时一次':
      return 3
    case '每8小时1次':
      return 3
    case '每八小时一次':
      return 3
    case '每八小时1次':
      return 3
    case '每12小时一次':
      return 2
    case '每12小时1次':
      return 2
    case '每十二小时一次':
      return 2
    case '每十二小时1次':
      return 2
    case '每晚一次':
      return 1
    case '每晚1次':
      return 1
    case '每天一次':
      return 1
    case '每天1次':
      return 1
    case '每日一次':
      return 1
    case '每日1次':
      return 1
    case '每天二次':
      return 2
    case '每天2次':
      return 2
    case '每天三次':
      return 3
    case '每天3次':
      return 3
    case '每日三次':
      return 3
    case '每日3次':
      return 3
    case '每天四次':
      return 4
    case '每天4次':
      return 4
    case '每日四次':
      return 4
    case '每日4次':
      return 4
    case '每天五次':
      return 5
    case '每天5次':
      return 5
    case '每日五次':
      return 5
    case '每日5次':
      return 5
    case '隔天一次':
      return 0.5
    case '隔日一次':
      return 0.5
    case '隔日1次':
      return 0.5
    case '隔天1次':
      return 0.5
    case '每三天一次':
      return 0.3333
    case '每三天1次':
      return 0.3333
    case '每3天1次':
      return 0.3333
    case '每3天一次':
      return 0.3333
    case '五天一次':
      return 0.2
    case '五天1次':
      return 0.2
    case '5天一次':
      return 0.2
    case '5天1次':
      return 0.2
    case '五日一次':
      return 0.2
    case '五日1次':
      return 0.2
    case '5日一次':
      return 0.2
    case '5日1次':
      return 0.2
    case '十天一次':
      return 0.1
    case '十天1次':
      return 0.1
    case '10天一次':
      return 0.1
    case '10天1次':
      return 0.1
    case '十日一次':
      return 0.1
    case '十日1次':
      return 0.1
    case '10日一次':
      return 0.1
    case '10日1次':
      return 0.1
    case '每周一次':
      return 0.1428
    case '每周1次':
      return 0.1428
    case '每周二次':
      return 0.2857
    case '每周2次':
      return 0.2857
    case '每周三次':
      return 0.4285
    case '每周3次':
      return 0.4285
    case '每二周一次':
      return 0.0714
    case '每二周1次':
      return 0.0714
    case '每2周1次':
      return 0.0714
    case '每2周一次':
      return 0.0714
    default:
      return 0
  }
}

export function  getFeesStatusDisplay (feesStatus: any){
    if (feesStatus == '0') {
        return { color: '#FA8714', text: '待收费' }
    } else if (feesStatus == '3') {
        return { color: '#999999', text: '已结算' }
    } else if (feesStatus == '5') {
        return { color: 'red', text: '已退费' }
    }
    return { color: '#999999', text: '' }
}
